<div class="card mb-5" id="card-config">
    <div class="head">
        <h1>Licenças</h1>
        <div class="d-flex flex-row justify-content-between pb-1">
            <span>Lista de licenças adquiridas</span>
            <div>
                <button class="btn-nav" routerLink="../licencas/cadastro"
                    *ngIf="verificarPermissao(['cadastrar_licenca'])">
                    <img src="../../assets/add.png" alt="Cadastrar" class="mr-1">Cadastrar licença
                </button>
                <button class="btn-nav" routerLink="../licencas/adquirirLicenca"
                    *ngIf="verificarPermissao(['adquirir_licenca'])">
                    <img src="../../assets/certificate.png" alt="Licença" class="mr-1">Adquirir licença
                </button>
                <button class="btn-nav" (click)="gerarTokensPDF()">
                    <mat-icon class="mr-1">description</mat-icon>Baixar PDF
                </button>
            </div>
        </div>
        <div class="d-flex flex-row pb-1 ml-3">
            <label> Licenças:
                <select class="form-control" type="number" [(ngModel)]="licencaFiltrada"
                    (ngModelChange)="mudancaDeFiltro()">
                    <option [value]="licenca.sr_id" *ngFor="let licenca of licencas">
                        {{licenca.vc_nome}}
                    </option>
                </select>
            </label>
            <label> Usina:
                <select class="form-control" type="number" [(ngModel)]="usinaFiltrada" 
                    (ngModelChange)="mudancaDeFiltro()">
                    <option value="0" *ngIf="verificarPermissao(['listar_todos_clientes'])">
                        Todas as usinas
                    </option>
                    <option [value]="usina.sr_id" *ngFor="let usina of usinas">
                        {{usina.vc_nome}}
                    </option>
                </select>
            </label>  
            <label>Pesquisar:
                <input id="searchbar" matInput (keyup)="pesquisarLicenca($event)" name="search" class="form-control" type="search">
            </label>
            <img src="../../assets/lupa.svg" class="lupa-input"> 
        </div>
    </div>

    <div class="row m-2 d-flex align-items-center justify-content-center" *ngIf="!carregando">
        <div class="col-auto" *ngFor="let status of qntLicencasAdquiridas" (click)="filtrarPorStatus(status.vc_status)">
            <div class="card-info" [ngClass]="{ 'card-selecionado': statusSelecionado == status.vc_status }">
                <div class="title m-0">
                    {{status.vc_status}}
                </div>
                <div class="data m-0">
                    {{status.it_quantidade}}
                </div>
            </div>
        </div>
    </div>

    <div class="table-responsive-sm mx-3 mt-3">
        <table mat-table [dataSource]="dataSource" matSort class="mat-table table">
            <ng-container *ngFor="let coluna of colunas">
                <ng-container [matColumnDef]="coluna">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">{{ formatarNomeColuna(
                        coluna ) }}</th>
                    <td mat-cell *matCellDef="let licencaAdquirida" class="text-center">{{
                        licencaAdquirida.js_informacoes_licenca[coluna] ?
                        licencaAdquirida.js_informacoes_licenca[coluna] : "-" }}</td>
                </ng-container>
            </ng-container>
            <ng-container matColumnDef="vc_nota_fiscal">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Nota Fiscal</th>
                <td mat-cell *matCellDef="let licencaAdquirida" class="text-center">{{licencaAdquirida?.vc_nota_fiscal ?
                    licencaAdquirida.vc_nota_fiscal : '-'}}</td>
            </ng-container>
            <ng-container matColumnDef="vc_os_manutencao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Manutencao</th>
                <td mat-cell *matCellDef="let licencaAdquirida" class="text-center">{{licencaAdquirida?.vc_os_manutencao
                    ? licencaAdquirida.vc_os_manutencao : '-'}}</td>
            </ng-container>
            <ng-container matColumnDef="vc_proposta">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Proposta</th>
                <td mat-cell *matCellDef="let licencaAdquirida" class="text-center">{{ licencaAdquirida.vc_proposta ==
                    null ? '-' :licencaAdquirida.vc_proposta}}</td>
            </ng-container>
            <ng-container matColumnDef="vc_status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Status</th>
                <td mat-cell *matCellDef="let licencaAdquirida" class="text-center">{{ licencaAdquirida.vc_status }}
                </td>
            </ng-container>
            <ng-container matColumnDef="ts_ativacao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Data de Ativação</th>
                <td mat-cell *matCellDef="let licencaAdquirida" class="text-center">{{licencaAdquirida.ts_ativacao |
                    date: "dd/MM/yyyy"}}</td>
            </ng-container>
            <ng-container matColumnDef="ts_expiracao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Data de Expiração</th>
                <td mat-cell *matCellDef="let licencaAdquirida" class="text-center">{{licencaAdquirida.ts_expiracao ==
                    null ? '-' :
                    licencaAdquirida.ts_expiracao | date: "dd/MM/yyyy" }}</td>
            </ng-container>
            <ng-container matColumnDef="ts_criado_em">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Criado em</th>
                <td mat-cell *matCellDef="let licencaAdquirida" class="text-center">{{licencaAdquirida.ts_criado_em |
                    date: "dd/MM/yyyy"}}</td>
            </ng-container>
            <ng-container matColumnDef="vc_nome">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Nome</th>
                <td mat-cell *matCellDef="let licencaAdquirida" class="text-center">{{ licencaAdquirida.usuario.vc_nome
                    }}</td>
            </ng-container>
            <ng-container matColumnDef="vc_alvo_tecnico_cancelamento">
                <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col" class="text-center">Alvo Tecnico</th>
                <td mat-cell *matCellDef="let licencaAdquirida" class="text-center">{{
                    licencaAdquirida.vc_alvo_tecnico_cancelamento == null ? '-' :
                    licencaAdquirida.vc_alvo_tecnico_cancelamento }}</td>
            </ng-container>
            <ng-container matColumnDef="vc_token">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Token</th>
                <td mat-cell *matCellDef="let licencaAdquirida" class="text-center">
                    <div class="d-flex align-items-center justify-content-center token">
                        <span *ngIf="!licencaAdquirida.ocultarTexto">{{ licencaAdquirida.vc_token }}</span>
                        <span *ngIf="licencaAdquirida.ocultarTexto" class="pt-1">{{ '*******' }}</span>

                        <img *ngIf="licencaAdquirida.ocultarTexto && verificarPermissao(['visualizar_token_licenca'])"
                            src="../../assets/ver.png" (click)="alternarOcultarTexto(licencaAdquirida)"
                            class="cursor-pointer mx-2">
                        <img *ngIf="!licencaAdquirida.ocultarTexto" src="../../assets/nao-ver.png"
                            (click)="alternarOcultarTexto(licencaAdquirida)" class="cursor-pointer mx-2">

                        <img src="../../assets/copiar.png" (click)="copiarTexto(licencaAdquirida.vc_token)"
                            class="cursor-pointer"
                            *ngIf="licencaAdquirida.vc_status != 'CANCELADO' && licencaAdquirida.vc_status != 'RENOVADO' && licencaAdquirida.vc_status != 'TROCADO' && verificarPermissao(['visualizar_token_licenca'])">
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="opcoes" class="text-center">
                <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"></th>
                <td mat-cell *matCellDef="let licencaAdquirida" class="text-center">
                    <div class="btn-group"
                        *ngIf="licencaAdquirida.vc_status != 'CANCELADO' && licencaAdquirida.vc_status != 'RENOVADO' && licencaAdquirida.vc_status != 'TROCADO'"
                        class="text-center">
                        <button type="button" class="dropdown-toggle botao-opcoes" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                            Opções
                        </button>
                        <div class="dropdown-menu botao-opcoes">
                            <a class="dropdown-item" (click)="cancelarLicenca(licencaAdquirida)"
                                *ngIf="licencaAdquirida.vc_status != 'EXPIRADO'">Cancelar</a>
                            <a class="dropdown-item" (click)="renovarOuTrocarLicencaOuEditar(licencaAdquirida, 'Trocar')"
                                *ngIf="licencaAdquirida.vc_status == 'ATIVO'">Trocar</a>
                            <a class="dropdown-item" (click)="renovarOuTrocarLicencaOuEditar(licencaAdquirida, 'Renovar')"
                                *ngIf="licencaAdquirida.vc_status == 'EXPIRADO'">Renovar</a>
                            <a class="dropdown-item" (click)="renovarOuTrocarLicencaOuEditar(licencaAdquirida, 'Editar')"
                                *ngIf="licencaAdquirida.vc_status == 'ATIVO'">Editar</a>
                        </div>
                    </div>
                    <div class="btn-group" *ngIf="licencaAdquirida.vc_status == 'CANCELADO'">
                        <button type="button" class="btn-group-info btn-cancelado" (click)="mostrarInformacoes(licencaAdquirida)">
                            informações
                    </button>
                </div>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <ng-container *ngIf="colunas.length == 0 && !carregando">
            <div class="d-flex justify-content-center">
                <p>Não existe licenças para a usina selecionada</p>
            </div>
        </ng-container>
        <mat-paginator [length]="count" [pageSize]="10" [pageSizeOptions]="[5, 10, 25]"
            aria-label="Select page"></mat-paginator>
    </div>
    
    <div class="w-100" *ngIf="exibirMensagemDeCopiadoParaAreaDeTranferencia"
        [ngClass]="{'visivel': exibirMensagemDeCopiadoParaAreaDeTranferencia}">
        <div class="alert alert-success d-flex justify-content-center w-auto alinhando-alerta" role="alert">
            Copiado para área de transferencia
        </div>
    </div>
</div>
<div class="load d-flex justify-content-center" *ngIf="carregando">
    <mat-progress-spinner diameter=30 class="example-margin" color="primary" mode="indeterminate" value="50">
    </mat-progress-spinner>
</div>